export default __webpack_public_path__ + "static/media/Name.15e81852.svg";